import React from 'react';
import {
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaClock,
  FaPhoneAlt,
} from 'react-icons/fa';

const TopBar = () => {
  return (
    <div className="site-topbar">
      <div className="container d-flex justify-content-between align-items-center py-2">
        <div className="d-flex align-items-center text-left site-topbar-info">
          <div className="mr-md-4 mb-1 mb-md-0 topbar-item">
            <FaEnvelope className="mr-1" />
            <strong>Email:</strong>{' '}
            <a href="mailto:info@icbfinexperts.com" className="text-white ml-1">
              info@icbfinexperts.com
            </a>
          </div>
          <div className="mr-md-4 mb-1 mb-md-0 topbar-item topbar-hide-sm">
            <FaMapMarkerAlt className="mr-1" />
            KN4 AVE- CAR FREE ZONE NEXT TO BK HQ
          </div>
          <div className="mr-md-4 mb-1 mb-md-0 topbar-item">
            <FaPhoneAlt className="mr-1" />
            <a href="tel:+250788393784" className="text-white ml-1">
              +250 788 393 784
            </a>
          </div>
          <div className="mb-1 mb-md-0 topbar-item topbar-hide-md">
            <FaClock className="mr-1" />
            Mon–Fri: 8AM – 6PM
          </div>
        </div>

        <div className="d-flex justify-content-center mt-2 mt-lg-0 site-topbar-socials">
          <a
            href="https://wa.me/250788393784"
            className="text-white mx-2"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <FaWhatsapp />
          </a>
          <a href="#!" className="text-white mx-2" aria-label="Facebook">
            <FaFacebook />
          </a>
          <a href="#!" className="text-white mx-2" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href="#!" className="text-white mx-2" aria-label="Twitter">
            <FaTwitter />
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
